module.exports = __webpack_public_path__ + "static/img/erp.4357493.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/digitalsoftware/erp.png
// module id = +H+p
// module chunks = 1